import { render, staticRenderFns } from "./PanelDashboards.vue?vue&type=template&id=574769d0"
import script from "./PanelDashboards.vue?vue&type=script&lang=ts"
export * from "./PanelDashboards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports